import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAuth } from '../context/AuthContext';
import { useVendorAuth } from '../context/VendorAuthContext';
import Slider from 'react-slick';
import { selectAllCoupons } from '../state/selectors';

const TopSellingOne = () => {
    const coupons = useSelector(selectAllCoupons);
    const navigate = useNavigate()
    const { isAuthenticated, isSubscribed } = useAuth();
    const { isVendorAuthenticated } = useVendorAuth();

    const arrowBaseStyle = {
        background: 'linear-gradient(135deg, #4da8e8 0%, #2575fc 100%)',
        border: 'none',
        boxShadow: '0 4px 12px rgba(37,117,252,0.32)',
        transition: 'opacity 0.15s, transform 0.15s, box-shadow 0.15s',
    };

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-next slick-arrow flex-center rounded-circle text-xl`}
                style={arrowBaseStyle}
                onMouseEnter={e => { e.currentTarget.style.opacity = '0.88'; e.currentTarget.style.boxShadow = '0 6px 18px rgba(37,117,252,0.45)'; }}
                onMouseLeave={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(37,117,252,0.32)'; }}
            >
                <i className="ph ph-caret-right" style={{ color: 'white' }} />
            </button>
        );
    }

    function SamplePrevArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle text-xl`}
                style={arrowBaseStyle}
                onMouseEnter={e => { e.currentTarget.style.opacity = '0.88'; e.currentTarget.style.boxShadow = '0 6px 18px rgba(37,117,252,0.45)'; }}
                onMouseLeave={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(37,117,252,0.32)'; }}
            >
                <i className="ph ph-caret-left" style={{ color: 'white' }} />
            </button>
        );
    }
    
    const handleCouponNavigateClick = (id) => {
        navigate(`/coupon/${id}`)
    }

    const sortedCoupons = [...coupons].sort((a, b) => (b.redemption_count || 0) - (a.redemption_count || 0));
    const maxRedemptions = Math.max(1, ...sortedCoupons.map(c => c.redemption_count || 0));
        

    const settings = {
        dots: false,
        arrows: true,
        infinite: sortedCoupons.length > 4,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 3,

                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,

                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,

                },
            },

        ],
    };

    return (
        <section className="top-selling-products pt-80">
            <style>{`
                .topsell1-card { box-shadow: 0 2px 16px rgba(0,0,0,0.05); border-color: #edf2f7 !important; }
                .topsell1-title { font-size: 20px; font-weight: 700; color: #0f172a; display: flex; align-items: center; gap: 10px; margin: 0; }
                .topsell1-accent { display: inline-block; width: 4px; height: 20px; background: linear-gradient(180deg, #4da8e8, #2575fc); border-radius: 2px; flex-shrink: 0; }
                .topsell1-view-all { font-size: 13px; font-weight: 600; color: #2575fc; padding: 6px 14px; border: 1px solid #dde9ff; border-radius: 99px; background: #f0f5ff; text-decoration: none; transition: background 0.15s, color 0.15s; }
                .topsell1-view-all:hover { background: #2575fc; color: #fff; }
                .topsell1-promo-box { box-shadow: 0 4px 20px rgba(0,0,0,0.1); }
                .topsell1-promo-box h6 { font-size: 17.5px; font-weight: 600; color: #374151; letter-spacing: 0.1px; }
                .topsell1-promo-box h5 { font-size: 27.5px; font-weight: 800; color: #0f172a; letter-spacing: -0.3px; }
                .topsell1-slider .slick-slide { height: 520px !important; margin: 0 !important; }
                .topsell1-slider .slick-slide > div { height: 100%; padding: 0 6px; box-sizing: border-box; }
            `}</style>
            <div className="container container-lg">
                <div className="border border-gray-100 p-24 rounded-16 topsell1-card">
                    <div className="section-heading mb-24">
                        <div className="flex-between flex-wrap gap-8">
                            <h5 className="topsell1-title">
                                <span className="topsell1-accent" />
                                Most Popular
                            </h5>
                            <div className="flex-align mr-point gap-16">
                                <Link to="/shop" state="Newly Added Deals" className="topsell1-view-all">View All Coupons →</Link>
                            </div>
                        </div>
                    </div>
                    <div className="row g-12">
                        <div className="col-md-4">
                            <div className="d-flex align-items-center justify-content-center position-relative rounded-16 overflow-hidden p-28 z-1 text-center h-100 topsell1-promo-box">
                                <img
                                    src="assets/images/bg/deal-bg.png"
                                    alt=""
                                    className="position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100"
                                />
                                <div className="py-xl-4 d-flex flex-column align-items-center justify-content-center text-center">
                                    <h6 className="mb-4 fw-semibold">Start Saving Now with the</h6>
                                    <h5 className="mb-40 fw-semibold">Fun Card</h5>
                                    <Link
                                        to="/cart"
                                        className="btn bg-neutral-600 text-white border-neutral-600 hover-bg-neutral-700 hover-text-white py-16 px-24 flex-center d-inline-flex rounded-pill gap-8 fw-medium"
                                        tabIndex={0}
                                    >
                                        Shop Now <i className="ph ph-shopping-cart text-xl d-flex" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="top-selling-product-slider arrow-style-two topsell1-slider">
                                <Slider {...settings}>
                                    {
                                        Array.isArray(sortedCoupons) && sortedCoupons.length > 0 ? (
                                            sortedCoupons.map((coupon, key) => {
                                                return (
                                        <div key={key} style={{ height: '100%' }}>
                                            <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2" style={{ display: 'flex', flexDirection: 'column' }}>
                                                <div
                                                    onClick={()=> {handleCouponNavigateClick(coupon.id)}}
                                                    className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                                                    style={{ overflow: 'hidden', flexShrink: 0 }}
                                                >
                                                    <span className="product-card__badge bg-main-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                                                        Hot
                                                    </span>
                                                    {coupon.image_url ? (
                                                        <img
                                                            src={coupon.image_url}
                                                            alt=""
                                                            style={{ width: '100%', height: '100%', maxWidth: 'none', maxHeight: 'none', objectFit: 'cover', position: 'absolute', inset: 0 }}
                                                        />
                                                    ) : (
                                                        <img
                                                            src="assets/images/thumbs/product-two-img7.png"
                                                            alt=""
                                                            className="w-auto max-w-unset"
                                                        />
                                                    )}
                                                </div>
                                                <div className="flex-align gap-4" style={{ marginTop: "12px", marginBottom: "8px", height: '24px', flexShrink: 0, overflow: 'hidden' }}>
                                                    {coupon.business_name ? (
                                                        <>
                                                            <span className="text-tertiary-600 text-sm d-flex"><i className="ph-fill ph-storefront" /></span>
                                                            <span className="text-lg fw-semibold text-gray-500" style={{ fontFamily: "var(--heading-font)", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block', minWidth: 0 }}>{coupon.business_name}</span>
                                                        </>
                                                    ) : null}
                                                </div>
                                                <div className="product-card__content w-100" style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
                                                    <div className="flex-align gap-6" style={{ flexShrink: 0 }}>
                                                        <div className="flex-align gap-4">
                                                            {[1,2,3,4,5].map(star => (
                                                                <span key={star} className={`text-xs fw-medium d-flex ${star <= Math.round(coupon.average_rating || 0) ? 'text-warning-600' : 'text-gray-300'}`}>
                                                                    <i className="ph-fill ph-star" />
                                                                </span>
                                                            ))}
                                                        </div>
                                                        <span className="text-xs fw-medium text-gray-500">{coupon.average_rating ?? "—"}</span>
                                                        <span className="text-xs fw-medium text-gray-500">
                                                            ({coupon.rating_count ?? 0})
                                                        </span>
                                                    </div>
                                                    <h6 className="title text-lg fw-semibold mt-12 mb-8" style={{ flexShrink: 0 }}>
                                                        <div
                                                            onClick={()=> {handleCouponNavigateClick(coupon.id)}}
                                                            className="link d-block"
                                                            tabIndex={0}
                                                            style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                        >
                                                            {coupon.title}
                                                        </div>
                                                    </h6>
                                                    <p className="text-sm text-gray-500 mb-12" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flexShrink: 0, minHeight: '20px' }}>
                                                        {coupon.description || ' '}
                                                    </p>
                                                    <div className="mt-auto" style={{ flexShrink: 0 }}>
                                                        <div>
                                                            <div
                                                                className="progress w-100 bg-color-three rounded-pill h-4"
                                                                role="progressbar"
                                                                aria-label="Redemptions"
                                                                aria-valuenow={Math.round(((coupon.redemption_count || 0) / maxRedemptions) * 100)}
                                                                aria-valuemin={0}
                                                                aria-valuemax={100}
                                                            >
                                                                <div
                                                                    className="progress-bar bg-tertiary-600 rounded-pill"
                                                                    style={{ width: `${Math.round(((coupon.redemption_count || 0) / maxRedemptions) * 100)}%` }}
                                                                />
                                                            </div>
                                                            <span className="text-gray-500 text-xs fw-medium mt-4 d-block">
                                                                {coupon.redemption_count || 0} Redemptions
                                                            </span>
                                                        </div>
                                                        <div className="product-card__price flex-align gap-4 mt-8 mb-8">
                                                            <span className="text-heading text-md fw-semibold">
                                                                ${coupon.dollar_savings_amount}
                                                            </span>
                                                            <span className="text-gray-500 text-sm fw-medium">In Savings</span>
                                                            <span style={{ width: '1px', height: '14px', backgroundColor: '#d1d5db', display: 'inline-block', margin: '0 4px' }} />
                                                            <span className="text-main-800 text-sm fw-semibold">{coupon.saving_percentage}% Off</span>
                                                        </div>
                                                        {!isVendorAuthenticated && (
                                                            isAuthenticated && isSubscribed ? (
                                                                <Link
                                                                    to={`/coupon/${coupon.id}`}
                                                                    className="product-card__cart w-100 btn bg-main-800 text-white hover-bg-main-700 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium w-100"
                                                                >
                                                                    Redeem Coupon <i className="ph ph-shopping-cart" />
                                                                </Link>
                                                            ) : (
                                                                <Link
                                                                    to={isAuthenticated ? "/cart" : "/account-login"}
                                                                    state={{ from: `/coupon/${coupon.id}` }}
                                                                    className="product-card__cart w-100 btn bg-main-800 text-white hover-bg-main-700 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium w-100"
                                                                >
                                                                    Buy Fun Card <i className="ph ph-shopping-cart" />
                                                                </Link>
                                                            )
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        )
                                            })
                                        ) : (
                                            <div>No coupons available</div>
                                        )
                                    }
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default TopSellingOne